import {
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  ScrollView,
  StyleSheet,
} from 'react-native';
import { SelectedSetsData } from '@/components/SetsSelectedData';
import { TemplateChoiceBanner } from '@/components/TemplateChoiceBanner';
import { useWordsetContext } from '@/contexts/WordSetContext/useWordsetContext';
import { Filter } from './Filter';
import { Header } from './Header';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollStyle: {
    flex: 1,
    gap: 20,
    margin: 28,
  },
});

export function SetsSelectedWrapper({ props }) {
  const {
    data,
    selectedWords,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    scrollViewRef,
    template,
  } = useWordsetContext();

  const propz = {
    data,
    selectedData: selectedWords,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    props,
    template,
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={{ flex: 1 }}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 80 : 0}
    >
      <SafeAreaView style={styles.container}>
        <Header props={props} />
        <ScrollView ref={scrollViewRef} style={styles.scrollStyle}>
          {!setId && !props.route.params.templateMode && (
            <TemplateChoiceBanner type="Word" />
          )}
          <Filter />
          <SelectedSetsData type="word" {...propz} />
        </ScrollView>
      </SafeAreaView>
    </KeyboardAvoidingView>
  );
}
